import * as React from 'react';
import { Typography } from '../typography';
import Image from 'next/image';
import Icons from 'const/icons';
import { CypressI } from 'interfaces/cypress';

export const EmptyState: React.FC<CypressI> = ({ dataCY }): JSX.Element => {
	return (
		<div
			data-cy={dataCY}
			className="flex flex-col w-full mt-20 justify-center items-center md:m-5"
		>
			<Image
				src={Icons.nodata}
				width={100}
				height={120}
				alt="empty state"
				unoptimized
			/>
			<Typography type="headline-2" className="font-bold mt-4">
				No results found
			</Typography>
			<Typography type="body-1" className="mt-3">
				Sorry, there are not results for this page
			</Typography>
		</div>
	);
};
